import { render, staticRenderFns } from "./HighlightResultsPdf.vue?vue&type=template&id=0f12c6fd&scoped=true"
import script from "./HighlightResultsPdf.vue?vue&type=script&lang=js"
export * from "./HighlightResultsPdf.vue?vue&type=script&lang=js"
import style0 from "./HighlightResultsPdf.vue?vue&type=style&index=0&id=0f12c6fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12c6fd",
  null
  
)

export default component.exports